// extracted by mini-css-extract-plugin
export var display = "TitleAndText-module--display--3ox6Z";
export var paragraphs = "TitleAndText-module--paragraphs--2E3lo";